import {
  List,
  Datagrid,
  TextField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  SearchInput,
  FunctionField,
  required
} from "react-admin";
import { Box, Avatar, Stack, Typography } from "@mui/material";

const opponentFilters = [
  <SearchInput key="q" source="q" alwaysOn placeholder="Cerca avversario..." />,
];

const LogoCell = (record) => {
  const name = record?.name || "";
  const logo = record?.logo_url || "";

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Avatar
        src={logo || undefined}
        alt={name}
        variant="rounded"
        sx={{ width: 36, height: 36, bgcolor: "action.hover" }}
      >
        {name?.slice(0, 1)?.toUpperCase()}
      </Avatar>

      <Box>
        <Typography fontWeight={700} lineHeight={1.2}>
          {name}
        </Typography>
        {logo ? (
          <Typography variant="caption" color="text.secondary">
            logo impostato
          </Typography>
        ) : (
          <Typography variant="caption" color="text.secondary">
            nessun logo
          </Typography>
        )}
      </Box>
    </Stack>
  );
};

export const OpponentList = () => (
  <List
    filters={opponentFilters}
    perPage={25}
    sort={{ field: "name", order: "ASC" }}
    sx={{ "& .RaList-content": { marginTop: 1 } }}
  >
    <Datagrid
      rowClick="edit"
      bulkActionButtons={false}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        "& .RaDatagrid-headerCell": { fontWeight: 800 },
        "& .RaDatagrid-rowCell": { py: 1.25 },
      }}
    >
      <TextField source="id" label="ID" />
      <FunctionField label="Avversario" render={(record) => LogoCell(record)} />
      <TextField source="logo_url" label="Logo URL" />
    </Datagrid>
  </List>
);

const OpponentForm = () => (
  <SimpleForm>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        gap: 2,
        alignItems: "start",
      }}
    >
      <TextInput
        source="name"
        label="Nome"
        validate={[required()]}
        fullWidth
      />

      <TextInput
        source="logo_url"
        label="Logo URL"
        fullWidth
        helperText="Incolla un URL diretto ad un'immagine (png/jpg/svg)"
      />

      {/* Preview logo (leggiamo il valore dal record corrente) */}
      <FunctionField
        label="Anteprima logo"
        render={(record) => {
          const name = record?.name || "Logo";
          const logo = record?.logo_url || "";
          return (
            <Avatar
              src={logo || undefined}
              alt={name}
              variant="rounded"
              sx={{
                width: 72,
                height: 72,
                bgcolor: "action.hover",
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              {name?.slice(0, 1)?.toUpperCase()}
            </Avatar>
          );
        }}
      />
    </Box>
  </SimpleForm>
);

export const OpponentEdit = () => (
  <Edit title="Modifica avversario">
    <OpponentForm />
  </Edit>
);

export const OpponentCreate = () => (
  <Create title="Nuovo avversario">
    <OpponentForm />
  </Create>
);
